/**
 * useOrderViewInitialization Composable
 * Simple adapter for OrderView initialization
 * Delegates all business logic to store actions
 * Compatible with Vue 2
 */

/**
 * Composable for initializing OrderView
 * @param {Object} store - Vuex store instance
 * @param {Object} router - Vue router instance
 * @returns {Object} Initialization methods
 */
export function useOrderViewInitialization(store, router) {
  if (!store) {
    console.warn("useOrderViewInitialization: Store instance is required");
    return {
      initialize: async () => {}
    };
  }

  /**
   * Initializes OrderView by delegating to store action
   * @param {string} storeAlias - Store alias from route
   */
  async function initialize(storeAlias) {
    try {
      await store.dispatch("store/initializeStore", { storeAlias });
    } catch (error) {
      // Handle 404 errors
      if (error?.isNotFound || error?.status === 404) {
        if (router) {
          await router.push({ name: "NotFound" });
        }
        return;
      }
      // Re-throw other errors
      throw error;
    }
  }

  return {
    initialize
  };
}
